import { Col, Container, Row } from "react-bootstrap";

export default function Footer() {
    return(
        <Container fluid style={{backgroundColor:"#2196F3", color:"#fff"}}>
        <Container className="footer">
            <Row>
                <Col sm="12" md="4" style={{paddingTop:"30px", paddingBottom:"30px"}}>
                    <h2 style={{borderBottom:"1px solid #f8f8f8"}}>Dr. V M Chariar</h2>
                    <p>Professor, Centre for Rural Development & Technology,
                    <br/>Indian Institute of Technology Delhi,
                    <br/>New Delhi 110 016</p>
                </Col>
                
                <Col sm="12" md="4" style={{paddingTop:"30px", paddingBottom:"30px"}}>
                    <h2 style={{borderBottom:"1px solid #f8f8f8"}}>Contact</h2>
                    <p>
                    <a href="mailto:chariarv@rdat.iitd.ac.in"> Email : chariarv@iitd.ac.in</a>
                    <br/>Tel : +91 11 2659 6358
                    <br/>Fax : +91 11 2659 1121
                    <br/>Skype : chariarv
                    </p>
                </Col>

                <Col sm="12" md="4" style={{paddingTop:"30px", paddingBottom:"30px"}}>
                    <h2 style={{borderBottom:"1px solid #f8f8f8"}}>Socials</h2>
                    <p>
                    <a href="https://in.linkedin.com/in/chariarv" target="_blank"><i className="bi bi-linkedin"></i> Linkedin</a>
                    <br/><a href="https://www.facebook.com/vijaychariar" target="_blank"><i className="bi bi-facebook"></i> Facebook</a>
                    <br/><a href="https://twitter.com/joy_is_you" target="_blank"><i className="bi bi-twitter"></i> Twitter</a>
                    <br/><a href="https://www.instagram.com/joyisyou_/" target="_blank"><i className="bi bi-instagram"></i> Instagram</a>
                    <br/><a href="https://www.youtube.com/@FrugalInnovationJoyLab" target="_blank"><i className="bi bi-youtube"></i> YoutTube</a>
                    </p>
                </Col>
            </Row>
        </Container>
        </Container>
    )
}